// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import businessCollectionActionTypes from './business-collection.types';

/** ***************** GET SEARCH BUSINESS LOAN LIST START *********************** */
export const fetchSearchBusinessLoanListStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_START,
	payload: getData,
});

export const getSearchBusinessLoanListSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const getSearchBusinessLoanListFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchSearchBusinessLoanListResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_RESET,
});

export const getSearchBusinessLoanListResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET SEARCH BUSINESS LOAN LIST END *********************** */

/** ***************** GET BUSINESS LOAN INFO START *********************** */
export const fetchBusinessLoanInfoStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_START,
	payload: getData,
});

export const getBusinessLoanInfoSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_SUCCESS,
	payload: successData,
});

export const getBusinessLoanInfoFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_FAILURE,
	payload: failureData,
});

export const fetchBusinessLoanInfoResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_RESPONSE_RESET,
});

export const getBusinessLoanInfoResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_RESPONSE_CHANGED,
});
/** ***************** GET BUSINESS LOAN INFO END *********************** */

/** ***************** UPDATE BUSINESS COLLECTION START *********************** */
export const updateBusinessCollectionStart = (getData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_START,
	payload: getData,
});

export const updateBusinessCollectionSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_SUCCESS,
	payload: successData,
});

export const updateBusinessCollectionFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_FAILURE,
	payload: failureData,
});

export const updateBusinessCollectionResponseResetStart = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_RESPONSE_RESET,
});

export const updateBusinessCollectionResponseChanged = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS COLLECTION END *********************** */

/** ***************** UPDATE BUSINESS COLLECTION START *********************** */
export const updateBusinessDeathStart = (getData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_START,
	payload: getData,
});

export const updateBusinessDeathSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_SUCCESS,
	payload: successData,
});

export const updateBusinessDeathFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_FAILURE,
	payload: failureData,
});

export const updateBusinessDeathResponseResetStart = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_RESPONSE_RESET,
});

export const updateBusinessDeathResponseChanged = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS COLLECTION END *********************** */

/** ***************** UPDATE BUSINESS COLLECTION START *********************** */
export const updateBusinessInterestWaiverStart = (getData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_START,
	payload: getData,
});

export const updateBusinessInterestWaiverSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_SUCCESS,
	payload: successData,
});

export const updateBusinessInterestWaiverFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_FAILURE,
	payload: failureData,
});

export const updateBusinessInterestWaiverResponseResetStart = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_RESET,
});

export const updateBusinessInterestWaiverResponseChanged = () => ({
	type: businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS COLLECTION END *********************** */

/** ***************** FETCH BUSINESS COLLECTION START *********************** */
export const fetchBusinessCollectionStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_COLLECTION_START,
	payload: getData,
});

export const fetchBusinessCollectionSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_COLLECTION_SUCCESS,
	payload: successData,
});

export const fetchBusinessCollectionFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_COLLECTION_FAILURE,
	payload: failureData,
});

export const fetchBusinessCollectionResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_COLLECTION_RESPONSE_RESET,
});

export const fetchBusinessCollectionResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS COLLECTION END *********************** */

/** ***************** FETCH BUSINESS WALLET START *********************** */
export const fetchBusinessWalletStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_WALLET_START,
	payload: getData,
});

export const fetchBusinessWalletSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_WALLET_SUCCESS,
	payload: successData,
});

export const fetchBusinessWalletFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_WALLET_FAILURE,
	payload: failureData,
});

export const fetchBusinessWalletResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_WALLET_RESPONSE_RESET,
});

export const fetchBusinessWalletResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_WALLET_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS WALLET END *********************** */

/** ***************** ADD BUSINESS WALLET START *********************** */
export const addBusinessWalletStart = (getData: any) => ({
	type: businessCollectionActionTypes.ADD_BUSINESS_WALLET_START,
	payload: getData,
});

export const addBusinessWalletSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.ADD_BUSINESS_WALLET_SUCCESS,
	payload: successData,
});

export const addBusinessWalletFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.ADD_BUSINESS_WALLET_FAILURE,
	payload: failureData,
});

export const addBusinessWalletResponseResetStart = () => ({
	type: businessCollectionActionTypes.ADD_BUSINESS_WALLET_RESPONSE_RESET,
});

export const addBusinessWalletResponseChanged = () => ({
	type: businessCollectionActionTypes.ADD_BUSINESS_WALLET_RESPONSE_CHANGED,
});
/** ***************** ADD BUSINESS WALLET END *********************** */

/** ***************** FETCH BUSINESS COLLECTION START *********************** */
export const fetchBusinessQrStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_QR_START,
	payload: getData,
});

export const fetchBusinessQrSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_QR_SUCCESS,
	payload: successData,
});

export const fetchBusinessQrFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_QR_FAILURE,
	payload: failureData,
});

export const fetchBusinessQrResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_QR_RESPONSE_RESET,
});

export const fetchBusinessQrResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_QR_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS COLLECTION END *********************** */

/** ***************** FETCH BUSINESS COLLECTION START *********************** */
export const fetchBusinessRepaymentStart = (getData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_START,
	payload: getData,
});

export const fetchBusinessRepaymentSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_SUCCESS,
	payload: successData,
});

export const fetchBusinessRepaymentFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_FAILURE,
	payload: failureData,
});

export const fetchBusinessRepaymentResponseResetStart = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_RESPONSE_RESET,
});

export const fetchBusinessRepaymentResponseChanged = () => ({
	type: businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS COLLECTION END *********************** */

/** ***************** FETCH BUSINESS COLLECTION START *********************** */
export const revertBusinessWalletStart = (getData: any) => ({
	type: businessCollectionActionTypes.DELETE_BUSINESS_WALLET_START,
	payload: getData,
});

export const revertBusinessWalletSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.DELETE_BUSINESS_WALLET_SUCCESS,
	payload: successData,
});

export const revertBusinessWalletFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.DELETE_BUSINESS_WALLET_FAILURE,
	payload: failureData,
});

export const revertBusinessWalletResponseResetStart = () => ({
	type: businessCollectionActionTypes.DELETE_BUSINESS_WALLET_RESPONSE_RESET,
});

export const revertBusinessWalletResponseChanged = () => ({
	type: businessCollectionActionTypes.DELETE_BUSINESS_WALLET_RESPONSE_CHANGED,
});
/** ***************** FETCH BUSINESS COLLECTION END *********************** */

/** ***************** UPDATE BUSINESS COLLECTION START *********************** */
export const revertBusinessCollectionStart = (getData: any) => ({
	type: businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_START,
	payload: getData,
});

export const revertBusinessCollectionSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_SUCCESS,
	payload: successData,
});

export const revertBusinessCollectionFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_FAILURE,
	payload: failureData,
});

export const revertBusinessCollectionResponseResetStart = () => ({
	type: businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_RESPONSE_RESET,
});

export const revertBusinessCollectionResponseChanged = () => ({
	type: businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_RESPONSE_CHANGED,
});
/** ***************** UPDATE BUSINESS COLLECTION END *********************** */

/** ***************** BUSINESS LOAN CARD PDF START *********************** */
export const getBusinessLoanCardPDFStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_START,
	payload: getData,
});

export const getBusinessLoanCardPDFSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_SUCCESS,
	payload: successData,
});

export const getBusinessLoanCardPDFFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_FAILURE,
	payload: failureData,
});

export const getBusinessLoanCardPDFResponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_RESPONSE_RESET,
});

export const getBusinessLoanCardPDFResponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_RESPONSE_CHANGED,
});

/** ***************** BUSINESS LOAN CARD PDF END *********************** */

/** ***************** BUSINESS REPAYMENT PDF START *********************** */
export const getBusinessRepaymentPDFStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_START,
	payload: getData,
});

export const getBusinessRepaymentPDFSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_SUCCESS,
	payload: successData,
});

export const getBusinessRepaymentPDFFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_FAILURE,
	payload: failureData,
});

export const getBusinessRepaymentPDFResponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_RESPONSE_RESET,
});

export const getBusinessRepaymentPDFResponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_RESPONSE_CHANGED,
});

/** ***************** BUSINESS REPAYMENT PDF END *********************** */

/** ***************** BUSINESS LOAN CARD REPORT START *********************** */
export const getBusinessLoanCardReportStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_START,
	payload: getData,
});

export const getBusinessLoanCardReportSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_SUCCESS,
	payload: successData,
});

export const getBusinessLoanCardReportFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_FAILURE,
	payload: failureData,
});

export const getBusinessLoanCardReportResponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_RESPONSE_RESET,
});

export const getBusinessLoanCardReportResponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_RESPONSE_CHANGED,
});

/** ***************** BUSINESS LOAN CARD REPORT END *********************** */

/** ***************** BUSINESS LOAN COLLECTION APPROVAL START *********************** */
export const businessLoanCollectionApprovalStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_START,
	payload: getData,
});

export const businessLoanCollectionApprovalSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_SUCCESS,
	payload: successData,
});

export const businessLoanCollectionApprovalFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_FAILURE,
	payload: failureData,
});

export const businessLoanCollectionApprovalResponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
});

export const businessLoanCollectionApprovalResponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED,
});

/** ***************** BUSINESS LOAN COLLECTION APPROVAL END *********************** */

/** ***************** BUSINESS LOAN COLLECTION PAID START *********************** */
export const businessCollectionLoanPaidStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_START,
	payload: getData,
});

export const businessCollectionLoanPaidSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_SUCCESS,
	payload: successData,
});

export const businessCollectionLoanPaidFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_FAILURE,
	payload: failureData,
});

export const businessCollectionLoanPaidReponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET,
});

export const businessCollectionLoanPaidReponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED,
});
/** ***************** BUSINESS LOAN COLLECTION PAID END *********************** */

/** ***************** BUSINESS LOAN COLLECTION ARREAR PAID START *********************** */
export const businessCollectionLoanPaidArrearStart = (getData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START,
	payload: getData,
});

export const businessCollectionLoanPaidArrearSuccess = (successData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS,
	payload: successData,
});

export const businessCollectionLoanPaidArrearFailure = (failureData: any) => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE,
	payload: failureData,
});

export const businessCollectionLoanPaidArrearReponseReset = () => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET,
});

export const businessCollectionLoanPaidArrearReponseChanged = () => ({
	type: businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED,
});
/** ***************** BUSINESS LOAN COLLECTION PAID ARREAR END *********************** */
